/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'menu',
        title   : 'Menu',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [

            {
                id   : 'Vie etudiante',
                title: 'Vie etudiante',
                type : 'collapsable',
                icon : 'heroicons_outline:chart-pie',
                roles: ['ROLE_ETUDIANT'],
                children:[
                    {
                        id   : 'Bulletin',
                        title: 'Bulletin',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/bulletin',
                        roles: ['ROLE_ETUDIANT'],
                    },
                    {
                        id   : 'Emploi du temps',
                        title: 'Emploi du temps',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/emploi-du-temps',
                        roles: ['ROLE_ETUDIANT']
                    },
                    {
                        id   : 'Reclamation',
                        title: 'Réclamation',
                        type : 'basic',
                        icon : 'heroicons_outline:clipboard-check',
                        link : '/reclamation',
                        roles: ['ROLE_ETUDIANT']
                    },
                ]
            },
            {
                id   : 'Stage et Mémoire',
                title: 'Stage et Mémoire',
                type : 'collapsable',
                icon : 'heroicons_outline:clipboard-check',
                roles: ['ROLE_ETUDIANT','ROLE_RESPONSABLE','ROLE_ALUMNI'],
                children:[
                    {
                        id   : 'suivi-encadrant',
                        title: 'Demande de Rencontre',
                        type : 'basic',
                        icon : 'heroicons_outline:clipboard-check',
                        link : '/suivi-encadrant',
                        roles: ['ROLE_ETUDIANT','ROLE_RESPONSABLE','ROLE_ALUMNI']
                    },
                    {
                        id   : 'offre',
                        title: 'Offre',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/offre',
                        roles: ['ROLE_ETUDIANT','ROLE_ALUMNI']
                    },
                    {
                        id   : 'Information Stage',
                        title: 'Information Stage',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/information-stage',
                        roles: ['ROLE_ETUDIANT','ROLE_ALUMNI']
                    },
                    {
                        id   : 'lettre-recommadation',
                        title: 'Lettre de recommadation',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/lettre-recommadation',
                        roles: ['ROLE_ETUDIANT','ROLE_ALUMNI']
                    }

                    
                ]
            },
            {
                id   : 'alumni',
                title: 'Alumni',
                type : 'collapsable',
                icon : 'heroicons_outline:clipboard-check',
                link : '/alumni',
                roles: ['ROLE_ETUDIANT','ROLE_ALUMNI'],
                children:[
                    {
                        id   : 'Liste',
                        title: 'Liste ',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-pie',
                        link : '/alumni',
                        roles: ['ROLE_ETUDIANT','ROLE_ALUMNI']
                    },
                ]
            }
        ]
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        tooltip : 'Dashboards',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        tooltip : 'Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        tooltip : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'user-interface',
        title   : 'UI',
        tooltip : 'UI',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'navigation-features',
        title   : 'Navigation',
        tooltip : 'Navigation',
        type    : 'aside',
        icon    : 'heroicons_outline:menu',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'DASHBOARDS',
        type    : 'group',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'APPS',
        type    : 'group',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id   : 'others',
        title: 'OTHERS',
        type : 'group'
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'user-interface',
        title   : 'User Interface',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'navigation-features',
        title   : 'Navigation Features',
        type    : 'aside',
        icon    : 'heroicons_outline:menu',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        type    : 'group',
        icon    : 'heroicons_outline:qrcode',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'group',
        icon    : 'heroicons_outline:document-duplicate',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'user-interface',
        title   : 'UI',
        type    : 'group',
        icon    : 'heroicons_outline:collection',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'navigation-features',
        title   : 'Misc',
        type    : 'group',
        icon    : 'heroicons_outline:menu',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
